import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, combineLatest, first, map } from 'rxjs';
import {
  CAMBIO_PASSWORD,
  CAMBIO_PASSWORD_SUCCESS,
  LOGIN,
  LOGIN_RESET,
  LOGIN_SUCCESS,
  LOGOUT,
  SET_COD_TIPOLOGIA_CP,
} from '../store/login/login.actions';
import {
  selectEsito,
  selectFullName,
  selectRole,
  selectUser,
  selectToken,
  selectHasAdminRole,
  selectHasAppRole,
  selectHasCeacRole,
  selectHasOrtRole,
  selectHasPclRole,
  selectHasRtRole,
  selectHasVrtRole,
  selectResponseCambioPassword,
  selectCodTipologiaRt,
  selectUserRtAcronym,
  selectHasAppRtRole,
  selectLoginData,
} from '../store/login/login.selector';
import { ILoginState, Utente } from '../store/login/login';
import {
  ADD_TOAST_NOTIFICATION,
  RETRIEVE_CONFIG,
  RETRIVE_CATALOGO_APPARTENENZA,
  RETRIVE_CLASSE_APPARTENENZA,
  RETRIVE_CLASSE_APPARTENENZA_SUCCESS,
  RETRIVE_COMUNI,
  RETRIVE_COMUNI_SUCCESS,
  RETRIVE_PROVINCE,
  RETRIVE_PROVINCE_SUCCESS,
  RETRIVE_REGIONI,
} from '../store/config/config.actions';
import {
  selectApplicationVersion,
  selectBasepath,
  selectCaptchaLength,
  selectCatalogoAppartenenza,
  selectClasseAppartenenza,
  selectComuni,
  selectIsMaintainance,
  selectProvince,
  selectRegioni,
  selectTentativeLogin,
  selectToastNotification,
} from '../store/config/config.selector';
import { LoginPayload } from '../interfaces/login-payload';
import {
  DOWNLOAD_DETTAGLIO_REPORT_PUNTO_POSTE,
  DOWNLOAD_DETTAGLIO_REPORT_PUNTO_POSTE_LOCKER,
  DOWNLOAD_LISTA_REPORT_PUNTO_POSTE,
  DOWNLOAD_LISTA_REPORT_PUNTO_POSTE_LOCKER,
  DOWNLOAD_REPORT_PUNTO_POSTE,
  DOWNLOAD_REPORT_PUNTO_POSTE_LOCKER,
  DOWNLOAD_RETI_LOCKER,
  DOWNLOAD_RETI_TERZE,
  RESET_RETE_TERZA_STORE,
  RETRIEVE_DETTAGLIO_PUNTO_POSTE,
  RETRIEVE_DETTAGLIO_PUNTO_POSTE_LOCKER,
  RETRIEVE_DETTAGLIO_PUNTO_POSTE_LOCKER_SUCCESS,
  RETRIEVE_DETTAGLIO_PUNTO_POSTE_SUCCESS,
  RETRIEVE_REPORT_PUNTO_POSTE_LOCKER,
  RETRIEVE_RETETERZA_REPORT,
  RETRIEVE_RETETERZA_REPORT_SUCCESS,
  RETRIEVE_RETILOCKER_REPORT,
} from '../store/third-party-report/third-party-report.actions';
import { RetrieveReteterzaReportPayload } from '../interfaces/retrieve-reteterza-report-payload';
import {
  selectDettaglioPuntoPoste,
  selectDettaglioPuntoPosteLocker,
  selectResponseReteterzaReport,
  selectReteterzaReport,
  selectRetiLockerReport,
  selectRetrievePuntoPosteLocker,
} from '../store/third-party-report/third-party-report.selector';
import {
  ResponseReteterzaReport,
  RetiTerze,
} from '../interfaces/response-reteterza-report';
import { IResponsePuntoPosteDetail } from '../interfaces/retrive-dettaglio-punto-poste';
import { IPayloadPuntoPosteDetail } from '../interfaces/retrive-report-punto-poste-payload';
import {
  PayloadAnagrafica,
  ResponseAggiuntaAnagrafica,
  ResponseAnagraphicManagement,
} from '../interfaces/response-anagraphic-management';
import {
  selectCurrentSiglaRete,
  selectResponseCrmo,
  selectResponseAddAnagrafica,
  selectResponseAnagrafica,
  selectResponseDocuments,
  selectResponseEditReteTerzaDettaglio,
  selectResponseInterfaceMonitoring,
  selectResponseReteTerzaDettaglio,
  selectResponseRisottomettiCrmo,
  selectResponseStoricoOperazioni,
  selectResponseRisottomettiSap,
  selectResponseRisottomettiDashboard,
  selectResponseSap,
  selectResponseDashboard,
  selectResponseInterfaceHistory,
  selectResponseOperazioniProgressivo,
  selectResponseNuovaOperazioneFile,
  selectResponseMal,
  selectResponseRam,
  selectResponseCd,
  selectResponseListaGestionePunti,
  selectResponseCambiostato,
  selectResponseAttivazioneMassivaFile,
  selectResponseConfermaAttivazioneMassivaFile,
  selectResponsePuntoPosteDetail,
  selectResponseCMP,
  selectResponseCP,
  selectResponseReportGiacenzaList,
  selectResponseStoricoInterfacceSap,
  selectResponseReportGiacenzaLockerList,
  selectResponseStoricoInterfacceDashboard,
  selectResponseStoricoIcon,
  selectResponseCambiostatoPps,
  selectResponseForzaturaPreAttivazioneFile,
  selectResponseConfermaForzaturaPreAttivazioneFile,
} from '../store/anagraphic/anagraphic.selector';
import {
  EDIT_THIRD_NETWORK_DETAIL,
  RETRIEVE_ADD_ANAGRAPHIC,
  RETRIEVE_ANAGRAPHIC,
  RETRIEVE_DOCUMENTS,
  RETRIEVE_INTERFACE_MONITORING_CRM,
  RETRIEVE_INTERFACE_MONITORING_SAP,
  RETRIEVE_INTERFACE_MONITORING_DASHBOARD,
  RETRIEVE_CRMO_DETAIL,
  RETRIEVE_RISOTTOMETTI_CRMO,
  RETRIEVE_OPERATION_HISTORY,
  RETRIEVE_THIRD_NETWORK_DETAIL,
  SET_CURRENT_SIGLA_RETE,
  RETRIEVE_SAP_DETAIL,
  RETRIEVE_RISOTTOMETTI_SAP,
  RETRIEVE_INTERFACE_HISTORY_CRM,
  DOWNLOAD_TEMPLATE_PRECOMPILED,
  RETRIEVE_OPERATION_PROGRESSIVE,
  UPLOAD_FILE_NEW_OPERATION,
  RETRIEVE_MAL,
  RETRIEVE_RAM,
  RETRIEVE_CD,
  RETRIEVE_POINTS_LIST,
  DOWNLOAD_REPORT_POINTS_MANAGEMENT,
  CHANGE_STATUS,
  RETRIEVE_DOCUMENTS_SUCCESS,
  DOWNLOAD_MASSIVE_ACTIVATION_PRECOMPILED,
  UPLOAD_FILE_MASSIVE_ACTIVATION,
  CONFIRM_FILE_MASSIVE_ACTIVATION,
  RETRIEVE_GESTIONE_PUNTOPOSTE,
  RETRIEVE_CMP_LIST,
  RETRIEVE_CP,
  RETRIEVE_AUDIT,
  RETRIEVE_REPORT_GIACENZE_LIST,
  RETRIEVE_REPORT_GIACENZE_LIST_SUCCESS,
  RETRIEVE_REPORT_GIACENZE_XLS,
  DOWNLOAD_MIG2,
  RETRIEVE_GESTIONE_PUNTOPOSTE_SUCCESS,
  RETRIEVE_POINTS_LIST_SUCCESS,
  RETRIEVE_INTERFACE_HISTORY_SAP,
  RETRIEVE_OPERATION_PROGRESSIVE_SUCCESS,
  RESET_ANAGRAPHIC_STORE,
  EDIT_THIRD_NETWORK_DETAIL_SUCCESS,
  RETRIEVE_OPERATION_HISTORY_SUCCESS,
  UPLOAD_FILE_MASSIVE_ACTIVATION_SUCCESS,
  RETRIEVE_CP_SUCCESS,
  RETRIEVE_INTERFACE_HISTORY_SAP_SUCCESS,
  RETRIEVE_INTERFACE_HISTORY_CRM_SUCCESS,
  RETRIEVE_INTERFACE_MONITORING_SUCCESS,
  RETRIEVE_INTERFACE_HISTORY_DASHBOARD,
  RETRIEVE_INTERFACE_HISTORY_DASHBOARD_SUCCESS,
  RETRIEVE_SAP_DETAIL_SUCCESS,
  RETRIEVE_DASHBOARD_DETAIL,
  CHANGE_STATUS_SUCCESS,
  RETRIEVE_CRMO_DETAIL_SUCCESS,
  RETRIEVE_DASHBOARD_DETAIL_SUCCESS,
  RETRIEVE_REPORT_GIACENZE_LOCKER_LIST_SUCCESS,
  RETRIEVE_REPORT_GIACENZE_LOCKER_LIST,
  RETRIEVE_REPORT_GIACENZE_LOCKER_XLS,
  RETRIEVE_RISOTTOMETTI_DASHBOARD,
  RETRIEVE_RISOTTOMETTI_DASHBOARD_ERROR,
  RETRIEVE_STORICO_ICON_SUCCESS,
  RETRIEVE_STORICO_ICON,
  CHANGE_STATUS_PPS,
  DOWNLOAD_PREACTIVATION_PRECOMPILED,
  DOWNLOAD_MASSIVE_PRE_ACTIVATION_PRECOMPILED,
  UPLOAD_FILE_PREACTIVATION,
  UPLOAD_FILE_PREACTIVATION_SUCCESS,
  CONFIRM_FILE_PREACTIVATION,
  UPLOAD_FILE_NEW_OPERATION_SUCCESS,
} from '../store/anagraphic/anagraphic.actions';
import {
  DOWNLOAD_RENDICONTAZIONE,
  RESET_RENDICONTAZIONE_STORE,
  RETRIEVE_RENDICONTAZIONI,
  RETRIEVE_RENDICONTAZIONI_SUCCESS,
} from '../store/rendicontazione/rendicontazione.actions';
import { ResponseRendicontazioni } from '../interfaces/response-rendicontazione';
import { selectRendicontazioni } from '../store/rendicontazione/rendicontazione.selector';
import { INotification } from '../interfaces/notification';
import {
  selectOperationMonitoring,
  selectOperationMonitoringDetail,
} from '../store/monitoring/monitoring.selector';

import {
  DOWNLOAD_MONITORING_REPORT,
  DOWNLOAD_MONITORING_REPORT_DASHBOARD,
  DOWNLOAD_MONITORING_REPORT_SAP,
  RESET_MONITORING_STORE,
  RETRIVE_DETAIL_MONITORING_OPERATION,
  RETRIVE_DETAIL_MONITORING_OPERATION_SUCCESS,
  RETRIVE_MONITORING_OPERATION,
  RETRIVE_MONITORING_OPERATION_SUCCESS,
} from '../store/monitoring/monitoring.actions';
import { ResponseReteTerzaDettaglio } from '../interfaces/response-rete-terza-dettaglio';
import {
  RetrieveInterfaceMonitoringCrm,
  RetrieveInterfaceMonitoringSap,
  RetrieveInterfaceMonitoringDashboard,
} from '../interfaces/retrieve-interface-monitoring';
import { ResponseInterfaceMonitoringCrm } from '../interfaces/response-interface-monitoring-crm';
import { ResponseInterfaceMonitoringSap } from '../interfaces/response-interface-monitoring-sap';
import { ResponseInterfaceMonitoringDashboard } from '../interfaces/response-interface-monitoring-dashboard';
import {
  IPayloadCambioPassword,
  IResponseCambioPassword,
} from '../interfaces/change-password';
import { PayloadRetrieveDocuments } from '../interfaces/retrieve-documents';
import { ResponseDocuments } from '../interfaces/response-documents';
import {
  PayloadCrm,
  PayloadSap,
  ResponseCRMO,
  ResponseSAP,
  ResponseDashboard,
  PayloadDashboard,
} from '../interfaces/response-monitoring-interface';
import {
  PayloadStoricoOperazioni,
  ResponseStoricoOperazioni,
} from '../interfaces/response-operation-history';
import {
  IComuni,
  IProvince,
  IRegioni,
  payloadComuni,
  payloadProvince,
} from '../interfaces/location';
import {
  ResponseInterfaceHistoryCrm,
  RetrieveInterfaceHistoryCrm,
} from '../interfaces/response-interface-history-crm';
import {
  IPayloadOperationMonitoring,
  IResponseMonitoringDetail,
  IResponseOperationMonitoring,
} from '../interfaces/monitoring';
import {
  ICollectPointPuntoPoste,
  IPayloadtemplatePuntoPoste,
} from '../interfaces/anagraphic-new-operation';
import { ResponseOperazioniProgressivo } from '../interfaces/response-operation-progressive';
import {
  IPayloadCd,
  IPayloadRam,
  IResponseCd,
  IResponseMal,
  IResponseRam,
} from '../interfaces/mal-ram-cd';
import {
  IPayloadCambioStato,
  IResponseCambioStato,
  IResponseCambioStatoPps,
  IResponseListaGestionePunti,
  ISingleObjectGestionePunti,
} from '../interfaces/points-management';
import {
  IPayloadConfermaCaricamentoAttivazioneMassiva,
  IResponseConfermaCaricamentoAttivazioneMassiva,
  IResponseUploadAttivazioneMassiva,
} from '../interfaces/attivazione-massiva';
import { IResponseReportPuntoPoste } from '../interfaces/response-report-punto-poste';
import {
  CREATE_UTENZA,
  DOWNLOAD_LDV_DOC,
  DOWNLOAD_UTILITY_REPORT_PUNTO_POSTE,
  RETRIEVE_GESTIONE_UTENZE,
  RETRIEVE_LISTA_RETE_TERZE,
  RETRIEVE_COMPENSI_RETE,
  RETRIEVE_COMPENSI_RETE_POST,
  RETRIEVE_COMPENSI_RETE_POST_SUCCESS,
  RETRIEVE_COMPENSI_RETE_SUCCESS,
  RETRIEVE_RETE_TERZA_LIST,
  RETRIEVE_RETE_TERZA_LIST_SUCCESS,
  UPLOAD_DOCUMENT_LDV,
  RETRIEVE_CONFIGURAZIONE_BOXLESS,
  RETRIEVE_CONFIGURAZIONE_BOXLESS_POST,
  RETRIEVE_NEARLIST_XLS,
  RETRIEVE_NEARLIST_UFF_POSTALE,
  DOWNLOAD_LISTA_RECAPITO,
  RETRIEVE_CD_GO,
  RETRIEVE_FRAZ,
  RETRIEVE_GO,
  RETRIEVE_RAM_GO,
  SEARCH_LISTA_RECAPITO,
  RETRIEVE_RECAPITO,
  SEARCH_LISTA_RECAPITO_SUCCESS,
  RETRIEVE_RECAPITO_SUCCESS,
  RETRIEVE_LISTA_CATALOGO_MATERIALE,
  RETRIEVE_LISTA_CLUSTER,
  SAVE_LISTA_CATALOGO_MATERIALE,
  RETRIEVE_CONFIGURAZIONE_APPROVIGIONAMENTO,
  SAVE_CONFIGURAZIONE_APPROVIGIONAMENTO,
  RETRIEVE_REGOLE_ORDINE,
  RETRIEVE_ORDER_HISTORY,
  DOWNLOAD_REPORT_ORDER_HISTORY,
  RETRIEVE_ORDER_HISTORY_SUCCESS,
  RETRIEVE_CREATE_ORDER,
  CHANGE_QUANTITY_CREATE_ORDER,
  RETRIEVE_CREATE_ORDER_SUCCESS,
  RETRIVE_LISTA_FRAZIONARIO,
  RESET_UTILITY_STORE,
  RETRIVE_LISTA_FRAZIONARIO_SUCCESS,
  RETRIEVE_PIN_RECOVERY,
} from '../store/utilities/utilities.actions';
import {
  selectCreazioneUtenza,
  selectGestioneUtenze,
  selectListaReteTerze,
  selectResponseCdGo,
  selectResponseCercaPerStrutturaRecapito,
  selectResponseCompensiRete,
  selectResponseCompensiRetePost,
  selectResponseConfigurazioneApprovvigionamento,
  selectResponseConfigurazioneBoxless,
  selectResponseConfigurazioneBoxlessPost,
  selectResponseCreazioneOrdine,
  selectResponseDocumentoLdv,
  selectResponseFraz,
  selectResponseFrazionarioList,
  selectResponseGo,
  selectResponseListaCatalogoMateriale,
  selectResponseListaCluster,
  selectResponseListFrazionario,
  selectResponsePinRecovery,
  selectResponseRamGo,
  selectResponseRecapito,
  selectResponseRegoleOrdine,
  selectResponseReteTerzaList,
  selectResponseStoricoOrdini,
} from '../store/utilities/utilities.selector';
import {
  IPayloadCreazioneUtenza,
  IResponseCreazioneUtenza,
  IResponseGestioneUtenze,
} from '../interfaces/gestione-utenze';
import { DownloadDetailReportPostPoint } from '../interfaces/download-detail-report-post-point';
import { RETRIEVE_UTILITY_LDV } from '../store/utilities/utilities.actions';
import { selectResponseUtilityLdv } from '../store/utilities/utilities.selector';
import { RetrieveUtilityLdv } from '../interfaces/retrieve-utility-ldv';
import { GenericResponse } from '../interfaces/generic-response';
import {
  IPayloadDownloadUtilityReportPuntoPoste,
  IResponseListaReteTerze,
} from '../interfaces/utility-report-punto-poste';
import {
  IResponseCompensiRete,
  IResponseCompensiRetePost,
} from '../interfaces/compensi';
import { IConfigurazioneBoxless } from '../interfaces/configurazione-boxless';
import { RetrieveGestionPuntoPoste } from '../interfaces/retrieve-gestione-puntoposte';
import {
  PayloadCP,
  ResponseCMP,
  ResponseCP,
} from '../interfaces/puntoposte-detail';
import {
  IPayloadReportGiacenzeXls,
  IResponseReportGiacenzeList,
} from '../interfaces/report-giacenze';
import {
  PayloadNearlistXls,
  ResponseNearlistUffPostale,
} from '../interfaces/nearlist';
import { IPayloadMig2Download } from '../interfaces/mig2';
import { ResponseCercaPerStrutturaRecapito } from '../interfaces/cerca-per-struttura-recapito';
import {
  IResponseGo,
  IResponseRamGo,
  IResponseCdGo,
  IResponseFraz,
  IPayloadRamGo,
  IPayloadCdGo,
  IPayloadGo,
  IPayloadFraz,
  IResponseRecapito,
} from '../interfaces/go';
import { PayloadCercaStrutturaRecapito } from '../interfaces/payload-cerca-struttura-recapito';
import {
  DOWNLOAD_EXPORT,
  EDIT_HEADER_STATE,
  EDIT_HEADER_STATE_SUCCESS,
  RETRIEVE_COMUNICATION_BOARD_LIST,
  RETRIEVE_COMUNICATION_BOARD_LIST_SUCCESS,
  RETRIEVE_DESTINATARI_BACHECA,
  RETRIEVE_DESTINATARI_BACHECA_SUCCESS,
  RETRIEVE_HEADER_DETAIL,
  RETRIEVE_HEADER_DETAIL_SUCCESS,
  RETRIEVE_INVIO_DETTAGLIO_MESSAGGI_BACHECA,
  RETRIEVE_INVIO_DETTAGLIO_MESSAGGI_BACHECA_SUCCESS,
  RETRIEVE_MESSAGGI_BACHECA,
  RETRIEVE_MESSAGGI_BACHECA_SUCCESS,
  RETRIEVE_ID_RECIPIENTS,
  RETRIEVE_HEADER_LIST,
  RETRIEVE_HEADER_LIST_SUCCESS,
  RETRIEVE_LISTA_RETE_TERZA,
  RETRIEVE_RECIPIENTS,
  RETRIEVE_REPORT_BACHECA,
  RETRIEVE_SAVE_DETTAGLIO_MESSAGGI_BACHECA,
  RETRIEVE_SAVE_DETTAGLIO_MESSAGGI_BACHECA_PUT,
  RETRIEVE_SAVE_DETTAGLIO_MESSAGGI_BACHECA_SUCCESS,
  RICHIEDI_EXPORT,
  SAVE_EDIT_HEADER_DETAIL,
  SAVE_EDIT_HEADER_DETAIL_SUCCESS,
  SAVE_HEADER_DETAIL,
  SAVE_HEADER_DETAIL_SUCCESS,
  SAVE_RECIPIENTS_LIST,
  VERIFY_RECIPIENTS_LIST,
  DOWNLOAD_EXPORT_BACHECA,
  DELETE_EL_BACHECA,
  EDIT_RECIPIENTS_LIST,
  EDIT_RECIPIENTS_LIST_SUCCESS,
  RICHIEDI_EXPORT_SUCCESS,
  RETRIEVE_INVIO_DETTAGLIO_MESSAGGI_BACHECA_PUT,
  DELETE_EL_BACHECA_SUCCESS,
} from '../store/communication/communication.actions';
import { ResponseRetrieveRecipients } from '../interfaces/retrieve-recipients';
import {
  selectBoardList,
  selectResponeDestinatariBacheca,
  selectResponeInvioDetailMessageBacheca,
  selectResponeMessaggiBacheca,
  selectResponeSaveDetailMessageBacheca,
  selectResponseEditSaveHeaderDetail,
  selectResponseHeaderEditState,
  selectResponseListaReteTerza,
  selectResponseRetrieveHeaderDetail,
  selectResponseRetrieveIdRecipients,
  selectResponseRetrieveHeaderList,
  selectResponseRetrieveRecipients,
  selectResponseRichiediExport,
  selectResponseSaveHeaderDetail,
  selectResponseVerifyRecipientsList,
  selectResponseDeleteElBacheca,
  selectReportBacheca,
  selectResponseEditRecipientsList,
} from '../store/communication/communication.selector';
import { IResponseRichiediExport } from '../interfaces/richiedi-export';
import {
  IPayloadStoricoSap,
  IResponseStoricoSap,
} from '../interfaces/response-interface-history-sap';
import {
  DOWNLOAD_PRECOMPILED_DOCUMENT_MASSIVE_UPLOAD,
  RESET_MASSIVE_UPLOADS_STORE,
  UPLOAD_FILE_MASSIVE,
  UPLOAD_FILE_MASSIVE_ASSOCIATION,
  UPLOAD_FILE_MASSIVE_DATA,
  UPLOAD_FILE_MASSIVE_DATA_ASSOCIATION,
  UPLOAD_FILE_MASSIVE_UTILITY,
  UPLOAD_FILE_MASSIVE_UTILITY_DATA,
} from '../store/massive-upload/massive-upload.actions';
import { IUploadFileResult } from '../store/massive-upload/massive-upload';
import {
  selectUploadFileDataResult,
  selectUploadFileResult,
} from '../store/massive-upload/massive-upload.selector';
import {
  IResponseListaCatalogoMateriale,
  ISaveListaCatalogoMateriale,
} from '../interfaces/catalogo-materiale';
import { CodeTipologiaCPEnum } from '../enum/cod-tipologia-cp.enum';
import { IResponseCluster } from '../interfaces/cluster';
import {
  IPayloadConfigurazioneApprovvigionamento,
  IResponseConfigurazioneApprovvigionamento,
  IResponseOrdiniApprovvigionamento,
} from '../interfaces/configurazione-approvvigionamento';
import { IResponseRegoleOrdine } from '../interfaces/regole-ordine';
import { PayloadOrderHistory } from '../interfaces/payload-order-history';
import { ResponseOrderHistory } from '../interfaces/response-order-history';
import { IDropdownOptions } from '@poste-click-connect/shared-ui';
import { ResponseCreazioneOrdine } from '../interfaces/response-creazione-ordine';
import { IResponseReteTerzaList } from '../interfaces/response-reteterza-list';
import { IResponseVerifyRecipientsList } from '../interfaces/response-verify-recipients-list';
import { IResponseRetrieveHeaderDetail } from '../interfaces/response-retrieve-header-detail';
import { PayloadHeaderDetail } from '../interfaces/payload-header-detail';
import {
  IDeleteElNoticeboard,
  IPayloadBoardList,
  ResponseComunicationBoardList,
} from '../interfaces/response-comunication-board-list';
import { ResponseMessageBoardList } from '../interfaces/messaggi-comunicazioni-bacheca';
import { ResponseRecipientsBoardList } from '../interfaces/destinatari-comunicazioni-bacheca';
import {
  IPayloadSaveDetailMessageBoardList,
  ResponseSaveDetailComunicationBoardList,
} from '../interfaces/response-save-detail-comunication-board-list';
import {
  IPayloadInvioDetailMessageBoardList,
  ResponseInvioDetailComunicationBoardList,
} from '../interfaces/response-invio-detail-comunication-board-list';
import { IPayloadSaveDetailMessageBoardListPut } from '../interfaces/response-save-detail-comunication-board-list-put';
import { ResponseIdRecipients } from '../interfaces/retrieve-id-recipientslist';
import { PayloadEditStateHeader } from '../interfaces/payload-edit-state-header';
import { ResponseReportBoardList } from '../interfaces/report-comunicazioni-bacheca';
import {
  IPayloadSaveRecipientsList,
  SaveRecipientsList,
} from '../interfaces/response-save-recipients-list';
import { RetrieveRetilockerReportPayload } from '../interfaces/retrieve-retiLocker-report-payload';
import { ResponseRetiLockerReport, RetiLocker } from '../interfaces/response-reti-locker-report';
import { IResponseReportPuntoPosteLocker } from '../interfaces/response-report-punto-poste-locker';
import { IPayloadPuntoPosteLocker, IPayloadPuntoPosteLockerDetail } from '../interfaces/retrieve-report-punto-poste-locker-payload';
import { IResponsePuntoPosteLockerDetail } from '../interfaces/retrieve-punto-poste-locker-detail';
import { DownloadDetailReportPostPointLocker } from '../interfaces/download-detail-report-post-point-locker';
import { IPayloadReportGiacenzeLockerXls, IResponseReportGiacenzeLockerList } from '../interfaces/report-giacenze-locker';
import { IPayloadStoricoDashboard, IResponseStoricoDashboard } from '../interfaces/response-interface-history-dashboard';
import { IPinRecoveryPayload, IResponsePinRecovery } from '../interfaces/pin-recovery';
import {
  IPayloadStoricoIcon,
  IResponseStoricoIcon,
} from '../interfaces/monitoraggio-storico-icon';
import { IPayloadConfermaCaricamentoPreAttivazione, IResponseConfermaCaricamentoPreAttivazione, IResponseUploadPreAttivazione } from '../interfaces/forzatura-preattivazione';

@Injectable({
  providedIn: 'root',
})
export class FacadeService {
  /**
   * GETTER
   */

  get guard() {
    return {
      selectToken$: ((): Observable<string> =>
        this.store$.select(selectToken))(),
      selectIsMaintainance$: ((): Observable<boolean | undefined> =>
        this.store$.select(selectIsMaintainance))(),
    };
  }

  get generic() {
    return {
      selectBasepath$: ((): Observable<string> =>
        this.store$.select(selectBasepath).pipe(
          first((basepath) => Boolean(basepath)),
          map((config) => config as string)
        ))(),
    };
  }

  get footer() {
    return {
      selectApplicationVersion$: ((): Observable<string> =>
        this.store$.select(selectApplicationVersion))(),
    };
  }

  get header() {
    return {
      selectFullName$: ((): Observable<string> =>
        this.store$.select(selectFullName))(),
      selectRole$: ((): Observable<string> => this.store$.select(selectRole))(),
      selectHasAdminRole$: ((): Observable<boolean> =>
        this.store$.select(selectHasAdminRole))(),
      selectHasAppRole$: ((): Observable<boolean> =>
        this.store$.select(selectHasAppRole))(),
      selectHasCeacRole$: ((): Observable<boolean> =>
        this.store$.select(selectHasCeacRole))(),
      selectHasOrtRole$: ((): Observable<boolean> =>
        this.store$.select(selectHasOrtRole))(),
      selectHasPclRole$: ((): Observable<boolean> =>
        this.store$.select(selectHasPclRole))(),
      selectHasRtRole$: ((): Observable<boolean> =>
        this.store$.select(selectHasRtRole))(),
      selectHasVrtRole$: ((): Observable<boolean> =>
        this.store$.select(selectHasVrtRole))(),
      selectCodTipologiaRt$: ((): Observable<string | undefined> =>
        this.store$.select(selectCodTipologiaRt))(),
      selectUserRtAcronym$: ((): Observable<string | undefined> =>
        this.store$.select(selectUserRtAcronym))(),
    };
  }

  get login() {
    return {
      selectConfig$: ((): Observable<number[]> =>
        combineLatest([
          this.store$.select(selectCaptchaLength),
          this.store$.select(selectTentativeLogin),
        ]).pipe(
          first((config) => config.every((val: number | undefined) => !!val)),
          map((config) => config as number[])
        ))(),
      selectEsito$: ((): Observable<string> =>
        this.store$.select(selectEsito))(),
      selectUser$: ((): Observable<Utente | undefined> =>
        this.store$.select(selectUser))(),
      selectLoginData$: ((): Observable<ILoginState | undefined> =>
        this.store$.select(selectLoginData))(),
    };
  }

  get changePassword() {
    return {
      selectResponseCambioPassword$:
        ((): Observable<IResponseCambioPassword | null> =>
          this.store$.select(selectResponseCambioPassword))(),
      selectUser$: ((): Observable<Utente | undefined> =>
        this.store$.select(selectUser))(),
    };
  }

  get documents() {
    return {
      selectResponseDocuments$: ((): Observable<ResponseDocuments | null> =>
        this.store$.select(selectResponseDocuments))(),
      selectCurrentSiglaRete$: ((): Observable<string | undefined> =>
        this.store$.select(selectCurrentSiglaRete))(),
    };
  }

  get thirdPartyReport() {
    return {
      reteterzaReport$: ((): Observable<Partial<RetiTerze>[] | null> =>
        this.store$.select(selectReteterzaReport))(),
      selectResponseReteterzaReport$: ((): Observable<ResponseReteterzaReport | null> =>
        this.store$.select(selectResponseReteterzaReport))(),
      retiLockerReport$: ((): Observable<Partial<RetiLocker>[] | null> =>
        this.store$.select(selectRetiLockerReport))(),
      puntoPosteLocker: ((): Observable<IResponseReportPuntoPosteLocker | null> =>
        this.store$.select(selectRetrievePuntoPosteLocker))(),
      dettaglioPuntoPoste$: ((): Observable<IResponsePuntoPosteDetail | null> =>
        this.store$.select(selectDettaglioPuntoPoste))(),
      dettaglioPuntoPosteLocker$: ((): Observable<IResponsePuntoPosteLockerDetail | null> =>
        this.store$.select(selectDettaglioPuntoPosteLocker))(),
    };
  }

  get anagraphic() {
    return {
      selectResponseAnagrafica$:
        ((): Observable<ResponseAnagraphicManagement | null> =>
          this.store$.select(selectResponseAnagrafica))(),
      selectCurrentSiglaRete$: ((): Observable<string | undefined> =>
        this.store$.select(selectCurrentSiglaRete))(),
      selectResponseReportGiacenzaList$: ((): Observable<
        IResponseReportGiacenzeList | undefined | null
      > => this.store$.select(selectResponseReportGiacenzaList))(),
      selectResponseReportGiacenzaLockerList$: ((): Observable<
        IResponseReportGiacenzeLockerList | null
      > => this.store$.select(selectResponseReportGiacenzaLockerList))(),
    };
  }

  get interfaceMonitoring() {
    return {
      selectCurrentSiglaRete$: ((): Observable<string | undefined> =>
        this.store$.select(selectCurrentSiglaRete))(),
      selectResponseInterfaceMonitoring$: ((): Observable<
        ResponseInterfaceMonitoringCrm | ResponseInterfaceMonitoringSap | ResponseInterfaceMonitoringDashboard |null
      > => this.store$.select(selectResponseInterfaceMonitoring))(),
    };
  }

  get ldv() {
    return {
      selectResponseUtilityLdv$: ((): Observable<RetrieveUtilityLdv | null> =>
        this.store$.select(selectResponseUtilityLdv))(),
      selectResponseDocumentoLdv$: ((): Observable<GenericResponse | null> =>
        this.store$.select(selectResponseDocumentoLdv))(),
    };
  }

  get rendicontazioni() {
    return {
      rendicontazioni$: ((): Observable<ResponseRendicontazioni | null> =>
        this.store$.select(selectRendicontazioni))(),
    };
  }

  get notification() {
    return {
      notificationMessage$: ((): Observable<INotification | null | undefined> =>
        this.store$.select(selectToastNotification))(),
    };
  }

  get addAnagraphic() {
    return {
      selectAddAnagrafica$:
        ((): Observable<ResponseAggiuntaAnagrafica | null> =>
          this.store$.select(selectResponseAddAnagrafica))(),
    };
  }

  get reteTerzaDettaglio() {
    return {
      selectResponseReteTerzaDettaglio$: ((): Observable<
        ResponseReteTerzaDettaglio | undefined | null
      > => this.store$.select(selectResponseReteTerzaDettaglio))(),
      selectCodTipologiaRt$: ((): Observable<string | undefined> =>
        this.store$.select(selectCodTipologiaRt))(),
    };
  }

  get editReteTerzaDettaglio() {
    return {
      selectResponseEditReteTerzaDettaglio$: ((): Observable<
        ResponseAggiuntaAnagrafica | undefined | null
      > => this.store$.select(selectResponseEditReteTerzaDettaglio))(),
    };
  }

  get monitoring() {
    return {
      selectOperationMonitoring$:
        ((): Observable<IResponseOperationMonitoring | null> =>
          this.store$.select(selectOperationMonitoring))(),
      selectOperationMonitoringDetail$:
        ((): Observable<IResponseMonitoringDetail | null> =>
          this.store$.select(selectOperationMonitoringDetail))(),
    };
  }

  get monitoringInterface() {
    return {
      selectMonitoringInterfaceDetailCrm$: ((): Observable<
        ResponseCRMO | undefined | null
      > => this.store$.select(selectResponseCrmo))(),
      selectMonitoringInterfaceDetailSap$: ((): Observable<
        ResponseSAP | undefined | null
      > => this.store$.select(selectResponseSap))(),
      selectMonitoringInterfaceDetailDashboard$: ((): Observable<
      ResponseDashboard | undefined | null
      > => this.store$.select(selectResponseDashboard))(),
    };
  }

  get risottometti() {
    return {
      selectResponseCrm$: ((): Observable<ResponseCRMO | undefined | null> =>
        this.store$.select(selectResponseRisottomettiCrmo))(),
      selectResponseSap$: ((): Observable<ResponseSAP | undefined | null> =>
        this.store$.select(selectResponseRisottomettiSap))(),
      selectResponseDashboard$: ((): Observable<ResponseDashboard | undefined | null> =>
        this.store$.select(selectResponseRisottomettiDashboard))(),
    };
  }

  get storicoOperazioni() {
    return {
      selectResponseStoricoOperazioni$: ((): Observable<
        ResponseStoricoOperazioni | undefined | null
      > => this.store$.select(selectResponseStoricoOperazioni))(),
    };
  }

  get locationData() {
    return {
      selectRegioni$: ((): Observable<IRegioni | undefined | null> =>
        this.store$.select(selectRegioni))(),
      selectProvince$: ((): Observable<IProvince | undefined | null> =>
        this.store$.select(selectProvince))(),
      selectComuni$: ((): Observable<IComuni | undefined | null> =>
        this.store$.select(selectComuni))(),
    };
  }
  get storicoInterfaccia() {
    return {
      selectResponseStoricoInterfaccia$: ((): Observable<
        ResponseInterfaceHistoryCrm | undefined | null
      > => this.store$.select(selectResponseInterfaceHistory))(),
    };
  }

  get storicoInterfaccieSap() {
    return {
      selectResponseStoricoInterfacceSap$: ((): Observable<
        IResponseStoricoSap | undefined | null
      > => this.store$.select(selectResponseStoricoInterfacceSap))(),
    };
  }

  get storicoInterfaccieDashboard() {
    return {
      selectResponseStoricoInterfacceDashboard$: ((): Observable<
        IResponseStoricoDashboard | undefined | null
      > => this.store$.select(selectResponseStoricoInterfacceDashboard))(),
    };
  }

  get storicoIcon() {
    return {
      selectResponseStoricoIcon$: ((): Observable<
        IResponseStoricoIcon | undefined | null
      > => this.store$.select(selectResponseStoricoIcon))(),
    };
  }

  get operazioniProgressivo() {
    return {
      selectResponseOperazioniProgressivo$: ((): Observable<
        ResponseOperazioniProgressivo | undefined | null
      > => this.store$.select(selectResponseOperazioniProgressivo))(),
    };
  }

  get massiveUpload() {
    return {
      selectUploadFileResult$: ((): Observable<IUploadFileResult | null> =>
        this.store$.select(selectUploadFileResult))(),
      selectUploadFileDataResult$: ((): Observable<GenericResponse | null> =>
        this.store$.select(selectUploadFileDataResult))(),
      selectHasAppRtRole$: ((): Observable<boolean> =>
        this.store$.select(selectHasAppRtRole))(),
      selectUserRtAcronym$: ((): Observable<string | undefined> =>
        this.store$.select(selectUserRtAcronym))(),
    };
  }

  get nuovaOperazione() {
    return {
      selectRole$: ((): Observable<string> => this.store$.select(selectRole))(),
      selectResponseNuovaOperazioneFile$: ((): Observable<any> =>
        this.store$.select(selectResponseNuovaOperazioneFile))(),
    };
  }

  get mal() {
    return {
      selectResponseMal$: ((): Observable<IResponseMal | undefined | null> =>
        this.store$.select(selectResponseMal))(),
    };
  }

  get ram() {
    return {
      selectResponseRam$: ((): Observable<IResponseRam | undefined | null> =>
        this.store$.select(selectResponseRam))(),
    };
  }

  get cd() {
    return {
      selectResponseCd$: ((): Observable<IResponseCd | undefined | null> =>
        this.store$.select(selectResponseCd))(),
    };
  }

  get go() {
    return {
      selectResponseGo$: ((): Observable<IResponseGo | null> =>
        this.store$.select(selectResponseGo))(),

      selectResponseRamGo$: ((): Observable<IResponseRamGo | null> =>
        this.store$.select(selectResponseRamGo))(),

      selectResponseCdGo$: ((): Observable<IResponseCdGo | null> =>
        this.store$.select(selectResponseCdGo))(),

      selectResponseFraz$: ((): Observable<IResponseFraz | null> =>
        this.store$.select(selectResponseFraz))(),

      selectResponseRecapito$: ((): Observable<IResponseRecapito | null> =>
        this.store$.select(selectResponseRecapito))(),
    };
  }

  get listaGestionePunti() {
    return {
      selectResponseListaGestionePunti$: ((): Observable<
        IResponseListaGestionePunti | undefined | null
      > => this.store$.select(selectResponseListaGestionePunti))(),
    };
  }

  get cambioStato() {
    return {
      selectResponseCambiostato$: ((): Observable<{
        responseCambioStato: IResponseCambioStato;
        payload: IPayloadCambioStato;
      } | null> => this.store$.select(selectResponseCambiostato))(),
      selectResponseCambiostatoPps$: ((): Observable<{
        responseCambioStato: IResponseCambioStatoPps;
        payload: IPayloadCambioStato;
      } | null> => this.store$.select(selectResponseCambiostatoPps))(),
    };
  }

  get attivazioneMassivaFile() {
    return {
      selectResponseAttivazioneMassivaFile$: ((): Observable<
        IResponseUploadAttivazioneMassiva | undefined | null
      > => this.store$.select(selectResponseAttivazioneMassivaFile))(),
    };
  }

  get confermaAttivazioneMassivaFile() {
    return {
      selectResponseConfermaAttivazioneMassivaFile$: ((): Observable<
        IResponseConfermaCaricamentoAttivazioneMassiva | undefined | null
      > => this.store$.select(selectResponseConfermaAttivazioneMassivaFile))(),
    };
  }

  get preAttivazione() {
    return {
      selectResponsePreAttivazioneFile$: ((): Observable<
        IResponseUploadPreAttivazione | undefined | null
        > => this.store$.select(selectResponseForzaturaPreAttivazioneFile))(),
      selectResponseConfermaPreAttivazioneFile$:  ((): Observable<
        IResponseConfermaCaricamentoPreAttivazione | undefined | null
        > => this.store$.select(selectResponseConfermaForzaturaPreAttivazioneFile))(),
    }
  }

  get gestioneUtenze() {
    return {
      selectRole$: ((): Observable<string> => this.store$.select(selectRole))(),
      selectGestioneUtenze$: ((): Observable<IResponseGestioneUtenze | null> =>
        this.store$.select(selectGestioneUtenze))(),
    };
  }
  get strutturaRecapito() {
    return {
      selectResponseCercaPerStrutturaRecapito$:
        ((): Observable<ResponseCercaPerStrutturaRecapito | null> =>
          this.store$.select(selectResponseCercaPerStrutturaRecapito))(),
    };
  }

  get creazioneUtenza() {
    return {
      selectRole$: ((): Observable<string> => this.store$.select(selectRole))(),
      selectCreazioneUtenza$: ((): Observable<
        IResponseCreazioneUtenza | undefined | null
      > => this.store$.select(selectCreazioneUtenza))(),
    };
  }

  get listaReteTerze() {
    return {
      selectRole$: ((): Observable<string> => this.store$.select(selectRole))(),
      selectListaReteTerze$: ((): Observable<
        IResponseListaReteTerze | undefined | null
      > => this.store$.select(selectListaReteTerze))(),
    };
  }

  get utilities() {
    return {
      selectResponseReteTerzaList$: ((): Observable<
        ResponseAnagraphicManagement | undefined | null
      > => this.store$.select(selectResponseReteTerzaList))(),
      selectResponseCompensiRete$: ((): Observable<
        IResponseCompensiRete | undefined | null
      > => this.store$.select(selectResponseCompensiRete))(),
      selectResponseCompensiRetePost$: ((): Observable<
        IResponseCompensiRetePost | undefined | null
      > => this.store$.select(selectResponseCompensiRetePost))(),
    };
  }

  get communication() {
    return {
      selectResponseReteTerzaList$: ((): Observable<
        IResponseReteTerzaList | undefined
      > => this.store$.select(selectResponseListaReteTerza))(),
    };
  }

  get configurazioneBoxless() {
    return {
      selectResponseConfigurazioneBoxless$: ((): Observable<
        IConfigurazioneBoxless | undefined | null
      > => this.store$.select(selectResponseConfigurazioneBoxless))(),
      selectResponseConfigurazioneBoxlessPost$: ((): Observable<
        IConfigurazioneBoxless | undefined | null
      > => this.store$.select(selectResponseConfigurazioneBoxlessPost))(),
    };
  }

  get gestionePuntoPosteDetail() {
    return {
      selectResponsePuntoPosteDetail$: ((): Observable<
        RetrieveGestionPuntoPoste | undefined | null
      > => this.store$.select(selectResponsePuntoPosteDetail))(),
      selectResponseCP$: ((): Observable<ResponseCP | undefined | null> =>
        this.store$.select(selectResponseCP))(),
    };
  }

  get cmpList() {
    return {
      selectResponseCMPList$: ((): Observable<ResponseCMP | undefined | null> =>
        this.store$.select(selectResponseCMP))(),
    };
  }

  get frazionario() {
    return {
      selectResponseFrazionarioList$: ((): Observable<
        ResponseNearlistUffPostale | undefined | null
      > => this.store$.select(selectResponseFrazionarioList))(),
    };
  }

  get comunication() {
    return {
      selectBoardList$: ((): Observable<ResponseComunicationBoardList | null> =>
        this.store$.select(selectBoardList))(),
      selectMessaggiBacheca$:
        ((): Observable<ResponseMessageBoardList | null> =>
          this.store$.select(selectResponeMessaggiBacheca))(),
      selectDestinatariBacheca$:
        ((): Observable<ResponseRecipientsBoardList | null> =>
          this.store$.select(selectResponeDestinatariBacheca))(),
      selectSaveDetailMessageBacheca$:
        ((): Observable<ResponseSaveDetailComunicationBoardList | null> =>
          this.store$.select(selectResponeSaveDetailMessageBacheca))(),
      selectInvioDetailMessageBacheca$:
        ((): Observable<ResponseInvioDetailComunicationBoardList | null> =>
          this.store$.select(selectResponeInvioDetailMessageBacheca))(),
      selectDeleteElNoticeboard$:
        ((): Observable<IDeleteElNoticeboard | null> =>
          this.store$.select(selectResponseDeleteElBacheca))(),
      selectReportBacheca$: ((): Observable<ResponseReportBoardList | null> =>
        this.store$.select(selectReportBacheca))(),
    };
  }
  get listaDestinatari() {
    return {
      selectResponseRetrieveRecipients$:
        ((): Observable<ResponseRetrieveRecipients | null> =>
          this.store$.select(selectResponseRetrieveRecipients))(),

      selectResponseRichiediExport$:
        ((): Observable<IResponseRichiediExport | null> =>
          this.store$.select(selectResponseRichiediExport))(),

      selectResponseVerifyRecipientsList$:
        ((): Observable<IResponseVerifyRecipientsList | null> =>
          this.store$.select(selectResponseVerifyRecipientsList))(),

      selectResponseRetrieveIdRecipients$:
        ((): Observable<ResponseIdRecipients | null> =>
          this.store$.select(selectResponseRetrieveIdRecipients))(),

      selectResponseEditRecipientsList$:
        ((): Observable<SaveRecipientsList | null> =>
          this.store$.select(selectResponseEditRecipientsList))(),
    };
  }

  get listaCatalogoMateriale() {
    return {
      selectResponseListaCatalogoMateriale$:
        ((): Observable<IResponseListaCatalogoMateriale | null> =>
          this.store$.select(selectResponseListaCatalogoMateriale))(),
    };
  }

  get listaCluster() {
    return {
      selectResponseListaCluster$: ((): Observable<IResponseCluster | null> =>
        this.store$.select(selectResponseListaCluster))(),
    };
  }

  get configurazioneApprovvigionamento() {
    return {
      selectResponseConfigurazioneApprovvigionamento$:
        ((): Observable<IResponseConfigurazioneApprovvigionamento | null> =>
          this.store$.select(selectResponseConfigurazioneApprovvigionamento))(),
    };
  }

  get regoleOrdine() {
    return {
      selectResponseRegoleOrdine$:
        ((): Observable<IResponseRegoleOrdine | null> =>
          this.store$.select(selectResponseRegoleOrdine))(),
    };
  }

  get storicoOrdini() {
    return {
      selectResponseStoricoOrdini$:
        ((): Observable<ResponseOrderHistory | null> =>
          this.store$.select(selectResponseStoricoOrdini))(),
    };
  }

  get creazioneOrdine() {
    return {
      selectCatalogoAppartenenza$: ((): Observable<IDropdownOptions<any>[]> =>
        this.store$.select(selectCatalogoAppartenenza))(),
      selectClasseAppartenenza$: ((): Observable<IDropdownOptions<any>[]> =>
        this.store$.select(selectClasseAppartenenza))(),
      selectResponseCreazioneOrdine$:
        ((): Observable<ResponseCreazioneOrdine | null> =>
          this.store$.select(selectResponseCreazioneOrdine))(),
      selectResponseListFrazionario$:
        ((): Observable<IResponseOrdiniApprovvigionamento | null> =>
          this.store$.select(selectResponseListFrazionario))(),
    };
  }

  get headerDetail() {
    return {
      selectResponseRetrieveHeaderDetail$:
        ((): Observable<IResponseRetrieveHeaderDetail | null> =>
          this.store$.select(selectResponseRetrieveHeaderDetail))(),
      selectSaveHeaderDetail$:
        ((): Observable<IResponseRetrieveHeaderDetail | null> =>
          this.store$.select(selectResponseSaveHeaderDetail))(),
      selectEditSaveHeaderDetail$:
        ((): Observable<IResponseRetrieveHeaderDetail | null> =>
          this.store$.select(selectResponseEditSaveHeaderDetail))(),
      selectRetrieveHeaderList$:
        ((): Observable<IResponseRetrieveHeaderDetail | null> =>
          this.store$.select(selectResponseRetrieveHeaderList))(),
      selectEditHeaderState$:
        ((): Observable<IResponseRetrieveHeaderDetail | null> =>
          this.store$.select(selectResponseHeaderEditState))(),
    };
  }

  get utilityPinRecovery() {
    return {
      selectPinRecovery$: ((): Observable<IResponsePinRecovery | null> =>
        this.store$.select(selectResponsePinRecovery))()
    }
  }

  constructor(private store$: Store) {}

  /**
   * DISPATCH
   */
  submitLogin(body: LoginPayload): void {
    this.store$.dispatch(LOGIN({ body }));
  }

  submitLogout(): void {
    this.store$.dispatch(LOGOUT());
  }

  successLogin(responseLogin: ILoginState): void {
    this.store$.dispatch(LOGIN_SUCCESS({ responseLogin }));
  }

  retrieveConfig(token: string): void {
    this.store$.dispatch(RETRIEVE_CONFIG({ token }));
  }

  retrieveReteterzaReport(payload: RetrieveReteterzaReportPayload): void {
    this.store$.dispatch(RETRIEVE_RETETERZA_REPORT({ payload }));
  }

  retrieveRetiLockerReport(payload: RetrieveRetilockerReportPayload): void {
    this.store$.dispatch(RETRIEVE_RETILOCKER_REPORT({ payload }));
  }

  retrievePuntoPosteLocker(payload: IPayloadPuntoPosteLocker): void {
    this.store$.dispatch(RETRIEVE_REPORT_PUNTO_POSTE_LOCKER({ payload }));
  }

  retriveDettaglioPuntoPoste(payload: IPayloadPuntoPosteDetail): void {
    this.store$.dispatch(RETRIEVE_DETTAGLIO_PUNTO_POSTE({ payload }));
  }

  resetDettaglioPuntoPoste(): void {
    this.store$.dispatch(
      RETRIEVE_DETTAGLIO_PUNTO_POSTE_SUCCESS({ dettaglioPuntoPoste: null })
    );
  }

  retrieveDettaglioPuntoPosteLocker(payload: IPayloadPuntoPosteLockerDetail): void {
    this.store$.dispatch(RETRIEVE_DETTAGLIO_PUNTO_POSTE_LOCKER({ payload }));
  }

  resetDettaglioPuntoPosteLocker(): void {
    this.store$.dispatch(
      RETRIEVE_DETTAGLIO_PUNTO_POSTE_LOCKER_SUCCESS({ dettaglioPuntoPosteLocker: null })
    );
  }

  retrieveRendicontazioni(): void {
    this.store$.dispatch(RETRIEVE_RENDICONTAZIONI());
  }

  resetRendicontazioni(): void {
    this.store$.dispatch(
      RETRIEVE_RENDICONTAZIONI_SUCCESS({ rendicontazioni: null })
    );
  }

  retrieveDownloadRendicontazioni(payload: string): void {
    this.store$.dispatch(DOWNLOAD_RENDICONTAZIONE({ payload }));
  }

  retrieveDownloadReportPuntoPoste(
    payload: Partial<IResponsePuntoPosteDetail>
  ): void {
    this.store$.dispatch(DOWNLOAD_REPORT_PUNTO_POSTE({ payload }));
  }

  retrieveDownloadListaReportPuntoPoste(
    payload: Partial<IResponseReportPuntoPoste>
  ): void {
    this.store$.dispatch(DOWNLOAD_LISTA_REPORT_PUNTO_POSTE({ payload }));
  }

  retrieveDownloadRetiTerze(payload: Partial<ResponseReteterzaReport>): void {
    this.store$.dispatch(DOWNLOAD_RETI_TERZE({ payload }));
  }

  retrieveDownloadRetiLocker(payload: RetrieveRetilockerReportPayload): void {
    this.store$.dispatch(DOWNLOAD_RETI_LOCKER({ payload }));
  }

  downloadDettaglioReportPuntoPosteLocker(
    payload: DownloadDetailReportPostPointLocker
  ): void {
    this.store$.dispatch(DOWNLOAD_DETTAGLIO_REPORT_PUNTO_POSTE_LOCKER({ payload }));
  }

  retrieveDownloadListaReportPuntoPosteLocker(
    payload: IPayloadPuntoPosteLocker
  ): void {
    this.store$.dispatch(DOWNLOAD_LISTA_REPORT_PUNTO_POSTE_LOCKER({ payload }));
  }

  retrieveDownloadReportPuntoPosteLocker(
    payload: Partial<IResponsePuntoPosteLockerDetail>
  ): void {
    this.store$.dispatch(DOWNLOAD_REPORT_PUNTO_POSTE_LOCKER({ payload }));
  }

  logout(): void {
    this.store$.dispatch(LOGIN_RESET());
    this.setCurrentSiglaRete('');
  }

  retrieveAnagrafica(): void {
    this.store$.dispatch(RETRIEVE_ANAGRAPHIC());
  }

  retrieveAddAnagraphic(payload: PayloadAnagrafica): void {
    this.store$.dispatch(RETRIEVE_ADD_ANAGRAPHIC({ payload }));
  }

  addNotification(notificationMessage: INotification): void {
    this.store$.dispatch(ADD_TOAST_NOTIFICATION({ notificationMessage }));
  }

  resetNotification(): void {
    this.store$.dispatch(ADD_TOAST_NOTIFICATION({ notificationMessage: null }));
  }

  retriveOperationMonitoring(
    payload: IPayloadOperationMonitoring,
    sigla: string
  ): void {
    this.store$.dispatch(RETRIVE_MONITORING_OPERATION({ payload, sigla }));
  }

  resetOperationMonitoring(): void {
    this.store$.dispatch(
      RETRIVE_MONITORING_OPERATION_SUCCESS({ operationMonitoring: null })
    );
  }

  retrieveReteTerzaDettaglio(payload: string): void {
    this.store$.dispatch(RETRIEVE_THIRD_NETWORK_DETAIL({ payload }));
  }

  retrieveEditReteTerzaDettaglio(payload: PayloadAnagrafica): void {
    this.store$.dispatch(EDIT_THIRD_NETWORK_DETAIL({ payload }));
  }

  resetEditReteTerzaDettaglio(): void {
    this.store$.dispatch(
      EDIT_THIRD_NETWORK_DETAIL_SUCCESS({
        responseModificaReteTerzaDettaglio: null,
      })
    );
  }

  retrieveInterfaceMonitoringCRM(
    payload: RetrieveInterfaceMonitoringCrm
  ): void {
    this.store$.dispatch(RETRIEVE_INTERFACE_MONITORING_CRM({ payload }));
  }

  retrieveInterfaceMonitoringSAP(
    payload: RetrieveInterfaceMonitoringSap
  ): void {
    this.store$.dispatch(RETRIEVE_INTERFACE_MONITORING_SAP({ payload }));
  }

  retrieveInterfaceMonitoringDashboard(
    payload: RetrieveInterfaceMonitoringDashboard
  ): void {
    this.store$.dispatch(RETRIEVE_INTERFACE_MONITORING_DASHBOARD({ payload }));
  }

  resetInterfaceMonitoring(): void {
    this.store$.dispatch(
      RETRIEVE_INTERFACE_MONITORING_SUCCESS({
        responseInterfaceMonitoring: null,
      })
    );
  }

  setCurrentSiglaRete(currentSiglaRete: string | null): void {
    this.store$.dispatch(SET_CURRENT_SIGLA_RETE({ currentSiglaRete }));
  }

  retriveMonitoringDetail(idOperazione: number): void {
    this.store$.dispatch(RETRIVE_DETAIL_MONITORING_OPERATION({ idOperazione }));
  }

  resetMonitoringDetail(): void {
    this.store$.dispatch(
      RETRIVE_DETAIL_MONITORING_OPERATION_SUCCESS({
        operationMonitoringDetail: null,
      })
    );
  }

  downlaodReportMonitoring(
    payload: any,
    rete: string,
    tab: string,
    fileName?: string
  ): void {
    this.store$.dispatch(
      DOWNLOAD_MONITORING_REPORT({ operazioni: payload, rete, tab, fileName })
    );
  }

  downlaodReportMonitoringSap(
    payload: any,
    rete: string,
    tab: string,
    fileName?: string
  ): void {
    this.store$.dispatch(
      DOWNLOAD_MONITORING_REPORT_SAP({
        operazioni: payload,
        rete,
        tab,
        fileName,
      })
    );
  }

  downlaodReportMonitoringDashboard(
    payload: any,
    rete: string,
    tab: string,
    fileName?: string
  ): void {
    this.store$.dispatch(
      DOWNLOAD_MONITORING_REPORT_DASHBOARD({
        operazioni: payload,
        rete,
        tab,
        fileName,
      })
    );
  }

  downlaodLdvDoc(payload: string): void {
    this.store$.dispatch(DOWNLOAD_LDV_DOC({ payload }));
  }

  retrieveCambioPassword(payload: IPayloadCambioPassword): void {
    this.store$.dispatch(CAMBIO_PASSWORD({ payload }));
  }

  resetCambioPassword(): void {
    this.store$.dispatch(
      CAMBIO_PASSWORD_SUCCESS({ responseCambioPassword: null })
    );
  }

  retrieveDocuments(payload: PayloadRetrieveDocuments): void {
    this.store$.dispatch(RETRIEVE_DOCUMENTS({ payload }));
  }

  resetDocumentsSuccess(): void {
    this.store$.dispatch(
      RETRIEVE_DOCUMENTS_SUCCESS({ responseDocuments: null })
    );
  }

  retrieveCrmo(idOperazione: string): void {
    this.store$.dispatch(RETRIEVE_CRMO_DETAIL({ idOperazione }));
  }

  resetCrmo(): void {
    this.store$.dispatch(RETRIEVE_CRMO_DETAIL_SUCCESS({ responseCrmo: null }));
  }

  resetDashboard(): void {
    this.store$.dispatch(RETRIEVE_DASHBOARD_DETAIL_SUCCESS({ responseDashboard: null }));
  }

  resetRisottomettiDashboard(): void {
    this.store$.dispatch(RETRIEVE_RISOTTOMETTI_DASHBOARD_ERROR({ responseRisottomettiDashboard: null }));
  }

  retrieveRisottomettiCrmo(payload: PayloadCrm): void {
    this.store$.dispatch(RETRIEVE_RISOTTOMETTI_CRMO({ payload }));
  }

  retrieveStoricoOperazioni(payload: PayloadStoricoOperazioni): void {
    this.store$.dispatch(RETRIEVE_OPERATION_HISTORY({ payload }));
  }

  resetStoricoOperazioni(): void {
    this.store$.dispatch(
      RETRIEVE_OPERATION_HISTORY_SUCCESS({ responseStoricoOperazioni: null })
    );
  }

  resetReportReteTerza(): void {
    this.store$.dispatch(
      RETRIEVE_RETETERZA_REPORT_SUCCESS({ reteterzaReport: null })
    );
  }

  retrieveSap(idOperazione: string): void {
    this.store$.dispatch(RETRIEVE_SAP_DETAIL({ idOperazione }));
  }

  retrieveDashboard(idOperazione: string): void {
    this.store$.dispatch(RETRIEVE_DASHBOARD_DETAIL({ idOperazione }));
  }

  cleanSap(): void {
    this.store$.dispatch(RETRIEVE_SAP_DETAIL_SUCCESS({ responseSap: null }));
  }

  retrieveRisottomettiSap(payload: PayloadSap): void {
    this.store$.dispatch(RETRIEVE_RISOTTOMETTI_SAP({ payload }));
  }

  retrieveRisottomettiDashboard(payload: PayloadDashboard): void {
    this.store$.dispatch(RETRIEVE_RISOTTOMETTI_DASHBOARD({ payload }));
  }

  retrieveCatalogoAppartenenza(): void {
    this.store$.dispatch(RETRIVE_CATALOGO_APPARTENENZA());
  }

  retrieveClasseAppartenenza(payload: { clusterAppartenenza: string }): void {
    this.store$.dispatch(RETRIVE_CLASSE_APPARTENENZA({ payload }));
  }

  resetClasseAppartenenza(): void {
    this.store$.dispatch(
      RETRIVE_CLASSE_APPARTENENZA_SUCCESS({ classeAppartenenza: [] })
    );
  }

  retrieveRegioni(): void {
    this.store$.dispatch(RETRIVE_REGIONI());
  }

  retriveProvince(payload: payloadProvince) {
    this.store$.dispatch(RETRIVE_PROVINCE({ payload }));
  }

  resetProvince() {
    this.store$.dispatch(RETRIVE_PROVINCE_SUCCESS({ province: null }));
  }

  retriveComuni(payload: payloadComuni) {
    this.store$.dispatch(RETRIVE_COMUNI({ payload }));
  }

  resetComuni() {
    this.store$.dispatch(RETRIVE_COMUNI_SUCCESS({ comuni: null }));
  }

  retrieveInterfaceHistoryCRM(payload: RetrieveInterfaceHistoryCrm): void {
    this.store$.dispatch(RETRIEVE_INTERFACE_HISTORY_CRM({ payload }));
  }

  resetInterfaceHistoryCRM(): void {
    this.store$.dispatch(
      RETRIEVE_INTERFACE_HISTORY_CRM_SUCCESS({ responseInterfaceHistory: null })
    );
  }

  retrieveInterfaceHistorySAP(payload: IPayloadStoricoSap): void {
    this.store$.dispatch(RETRIEVE_INTERFACE_HISTORY_SAP({ payload }));
  }

  resetInterfaceHistorySAP(): void {
    this.store$.dispatch(
      RETRIEVE_INTERFACE_HISTORY_SAP_SUCCESS({ responseStoricoSap: null })
    );
  }

  retrieveInterfaceHistoryDashboard(payload: IPayloadStoricoDashboard): void {
    this.store$.dispatch(RETRIEVE_INTERFACE_HISTORY_DASHBOARD({ payload }));
  }

  resetInterfaceHistoryDashboard(): void {
    this.store$.dispatch(
      RETRIEVE_INTERFACE_HISTORY_DASHBOARD_SUCCESS({ responseStoricoDashboard: null })
    );
  }

  retrieveDownloadTemplateNuovaOperazionePrecompilato(
    payload: IPayloadtemplatePuntoPoste,
    idOperazione: string,
    reteTerza: string,
    progressiveValue: string
  ): void {
    this.store$.dispatch(
      DOWNLOAD_TEMPLATE_PRECOMPILED({
        payload,
        idOperazione,
        reteTerza,
        progressiveValue,
      })
    );
  }

  retrieveOperazioniProgressivo(): void {
    this.store$.dispatch(RETRIEVE_OPERATION_PROGRESSIVE());
  }

  uploadNuovaOperazionefile(
    payload: any,
    idOperazione: string,
    reteTerza: string,
    isPut: boolean
  ): void {
    this.store$.dispatch(
      UPLOAD_FILE_NEW_OPERATION({ payload, idOperazione, reteTerza, isPut })
    );
  }

  downloadPrecopiledDocumentMassiveUpload(
    payload: any,
    code: string,
    isRecovery: boolean
  ): void {
    this.store$.dispatch(
      DOWNLOAD_PRECOMPILED_DOCUMENT_MASSIVE_UPLOAD({
        payload,
        code,
        isRecovery,
      })
    );
  }
  resetOperazioniProgressivo(): void {
    this.store$.dispatch(
      RETRIEVE_OPERATION_PROGRESSIVE_SUCCESS({
        responseOperazioniProgressivo: null,
      })
    );
  }

  uploadDocumentLdv(
    payload: FormData,
    idSpedizione: string,
    state: string
  ): void {
    this.store$.dispatch(UPLOAD_DOCUMENT_LDV({ payload, idSpedizione, state }));
  }

  retrieveMal(): void {
    this.store$.dispatch(RETRIEVE_MAL());
  }

  retrieveRam(payload?: IPayloadRam): void {
    this.store$.dispatch(RETRIEVE_RAM({ payload }));
  }

  retrieveRamGo(payload?: IPayloadRamGo): void {
    this.store$.dispatch(RETRIEVE_RAM_GO({ payload }));
  }

  retrieveRamStrutturaRecapito(payload?: IPayloadRam): void {
    this.store$.dispatch(RETRIEVE_RAM({ payload }));
  }

  retrieveCd(payload?: IPayloadCd): void {
    this.store$.dispatch(RETRIEVE_CD({ payload }));
  }

  retrieveCdGo(payload?: IPayloadCdGo): void {
    this.store$.dispatch(RETRIEVE_CD_GO({ payload }));
  }

  retrieveGo(payload?: IPayloadGo): void {
    this.store$.dispatch(RETRIEVE_GO({ payload }));
  }

  retrieveFraz(payload?: IPayloadFraz): void {
    this.store$.dispatch(RETRIEVE_FRAZ({ payload }));
  }

  retriveListaGestionePunti(payload: ICollectPointPuntoPoste): void {
    this.store$.dispatch(RETRIEVE_POINTS_LIST({ payload }));
  }

  downloadReportGestionePunti(
    payload: ISingleObjectGestionePunti[],
    isApt: boolean
  ): void {
    this.store$.dispatch(DOWNLOAD_REPORT_POINTS_MANAGEMENT({ payload, isApt }));
  }

  downloadDettaglioReportPuntoPoste(
    payload: DownloadDetailReportPostPoint
  ): void {
    this.store$.dispatch(DOWNLOAD_DETTAGLIO_REPORT_PUNTO_POSTE({ payload }));
  }

  retriveCambioStatoPuntoPoste(payload: IPayloadCambioStato): void {
    this.store$.dispatch(CHANGE_STATUS({ payload }));
  }

  retriveCambioStatoPPS(payload: IPayloadCambioStato): void {
    this.store$.dispatch(CHANGE_STATUS_PPS({ payload }));
  }

  resetCambioStatoPuntoPoste(): void {
    this.store$.dispatch(
      CHANGE_STATUS_SUCCESS({ responseCambioStatoWithPayload: null })
    );
  }

  retrieveDownloadAttivazioneMassivaPrecompilato(
    payload: { action4: string },
    reteTerza: string
  ): void {
    this.store$.dispatch(
      DOWNLOAD_MASSIVE_ACTIVATION_PRECOMPILED({ payload, reteTerza })
    );
  }

  uploadAttivazioneMassivafile(payload: FormData): void {
    this.store$.dispatch(UPLOAD_FILE_MASSIVE_ACTIVATION({ payload }));
  }

  resetUploadAttivazioneMassivafile(): void {
    this.store$.dispatch(
      UPLOAD_FILE_MASSIVE_ACTIVATION_SUCCESS({
        responseAttivazioneMassivaFile: null,
      })
    );
  }

  confirmAttivazioneMassivafile(
    payload: IPayloadConfermaCaricamentoAttivazioneMassiva
  ): void {
    this.store$.dispatch(CONFIRM_FILE_MASSIVE_ACTIVATION({ payload }));
  }

  retrieveDownloadPreAttivazionePrecompilato(
    payload: { action4: string },
    reteTerza: string
  ): void {
    this.store$.dispatch(
      DOWNLOAD_PREACTIVATION_PRECOMPILED({ payload, reteTerza })
    );
  }

  retrieveDownloadPreAttivazioneMassivaPrecompilato(
    payload: { action4: string },
    reteTerza: string
  ): void {
    this.store$.dispatch(
      DOWNLOAD_MASSIVE_PRE_ACTIVATION_PRECOMPILED({ payload, reteTerza })
    );
  }

  uploadPreAttivazioneFile(payload: FormData): void {
    this.store$.dispatch(UPLOAD_FILE_PREACTIVATION({ payload }));
  }
  
  resetUploadPreAttivazionefile(): void {
    this.store$.dispatch(
      UPLOAD_FILE_PREACTIVATION_SUCCESS({
        responsePreAttivazioneFile: null,
      })
    );
  }

  confirmPreAttivazionefile(payload: IPayloadConfermaCaricamentoPreAttivazione): void {
    this.store$.dispatch(CONFIRM_FILE_PREACTIVATION({ payload }));
  }

  retrieveUtilityLdv(payload: string): void {
    this.store$.dispatch(RETRIEVE_UTILITY_LDV({ payload }));
  }

  retrieveGestioneUtenze(): void {
    this.store$.dispatch(RETRIEVE_GESTIONE_UTENZE());
  }

  retrieveCreazioneUtenza(payload: IPayloadCreazioneUtenza): void {
    this.store$.dispatch(CREATE_UTENZA({ payload }));
  }

  retrieveListaReteTerze(): void {
    this.store$.dispatch(RETRIEVE_LISTA_RETE_TERZE());
  }

  downloadUtilityReportPuntoPoste(
    payload: IPayloadDownloadUtilityReportPuntoPoste
  ): void {
    this.store$.dispatch(DOWNLOAD_UTILITY_REPORT_PUNTO_POSTE({ payload }));
  }

  retrieveReteTerzaList(): void {
    this.store$.dispatch(RETRIEVE_RETE_TERZA_LIST());
  }

  resetReteTerzaList(): void {
    this.store$.dispatch(
      RETRIEVE_RETE_TERZA_LIST_SUCCESS({ responseReteTerzaList: null })
    );
  }

  retrieveCompensiRete(rete: string): void {
    this.store$.dispatch(RETRIEVE_COMPENSI_RETE({ rete }));
  }

  resetResponseCompensiRete(): void {
    this.store$.dispatch(
      RETRIEVE_COMPENSI_RETE_SUCCESS({ responseCompensiRete: null })
    );
  }

  retrieveCompensiRetePost(rete: string, file: FormData): void {
    this.store$.dispatch(RETRIEVE_COMPENSI_RETE_POST({ rete, file }));
  }
  resetResponseCompensiRetePost(): void {
    this.store$.dispatch(
      RETRIEVE_COMPENSI_RETE_POST_SUCCESS({ responseCompensiRetePost: null })
    );
  }

  retrieveConfigurazioneBoxless(): void {
    this.store$.dispatch(RETRIEVE_CONFIGURAZIONE_BOXLESS());
  }

  retrieveConfigurazioneBoxlessPost(payload: IConfigurazioneBoxless): void {
    this.store$.dispatch(RETRIEVE_CONFIGURAZIONE_BOXLESS_POST({ payload }));
  }

  retrieveGestionePuntoPoste(idPuntoPoste?: string): void {
    this.store$.dispatch(RETRIEVE_GESTIONE_PUNTOPOSTE({ idPuntoPoste }));
  }

  retrieveCMPList(): void {
    this.store$.dispatch(RETRIEVE_CMP_LIST());
  }

  retrieveCP(payload: PayloadCP): void {
    this.store$.dispatch(RETRIEVE_CP({ payload }));
  }

  downloadAudit(idPuntoPoste: string): void {
    this.store$.dispatch(RETRIEVE_AUDIT({ idPuntoPoste }));
  }

  retrieveReportGiacenzaList(idPuntoPoste: string): void {
    this.store$.dispatch(RETRIEVE_REPORT_GIACENZE_LIST({ idPuntoPoste }));
  }
  resetReportGiacenzaList(): void {
    this.store$.dispatch(
      RETRIEVE_REPORT_GIACENZE_LIST_SUCCESS({
        responseReportGiacenzeList: undefined,
      })
    );
  }
  retrieveReportGiacenzaXls(payload: IPayloadReportGiacenzeXls): void {
    this.store$.dispatch(RETRIEVE_REPORT_GIACENZE_XLS({ payload }));
  }

  retrieveReportGiacenzaLockerList(idPuntoPosteLocker: string): void {
    this.store$.dispatch(RETRIEVE_REPORT_GIACENZE_LOCKER_LIST({ idPuntoPosteLocker }));
  }

  resetReportGiacenzaLockerList(): void {
    this.store$.dispatch(
      RETRIEVE_REPORT_GIACENZE_LOCKER_LIST_SUCCESS({
        responseReportGiacenzeLockerList: null,
      })
    );
  }

  retrieveReportGiacenzaLockerXls(payload: IPayloadReportGiacenzeLockerXls): void {
    this.store$.dispatch(RETRIEVE_REPORT_GIACENZE_LOCKER_XLS({ payload }));
  }

  retrieveFrazionarioList(uffPostale: string): void {
    this.store$.dispatch(RETRIEVE_NEARLIST_UFF_POSTALE({ uffPostale }));
  }

  downloadFrazionario(payload: PayloadNearlistXls): void {
    this.store$.dispatch(RETRIEVE_NEARLIST_XLS({ payload }));
  }

  downloadMig2(payload: IPayloadMig2Download): void {
    this.store$.dispatch(DOWNLOAD_MIG2({ payload }));
  }

  searchListaRecapito(payload: PayloadCercaStrutturaRecapito): void {
    this.store$.dispatch(SEARCH_LISTA_RECAPITO({ payload }));
  }

  resetListaRecapito(): void {
    this.store$.dispatch(
      SEARCH_LISTA_RECAPITO_SUCCESS({ responseCercaRecapito: null })
    );
  }

  downloadListaRecapitoFile(
    payload: Partial<ResponseCercaPerStrutturaRecapito>
  ): void {
    this.store$.dispatch(DOWNLOAD_LISTA_RECAPITO({ payload }));
  }

  retrieveResponseRecapito(idFraz: string): void {
    this.store$.dispatch(RETRIEVE_RECAPITO({ idFraz }));
  }
  resetResponseRecapito(): void {
    this.store$.dispatch(RETRIEVE_RECAPITO_SUCCESS({ responseRecapito: null }));
  }

  retrieveResponseBoardList(payload: IPayloadBoardList): void {
    this.store$.dispatch(RETRIEVE_COMUNICATION_BOARD_LIST({ payload }));
  }

  resetResponseBoardList(): void {
    this.store$.dispatch(
      RETRIEVE_COMUNICATION_BOARD_LIST_SUCCESS({ responseBoardList: null })
    );
  }

  retrieveRecipients(): void {
    this.store$.dispatch(RETRIEVE_RECIPIENTS());
  }

  retrieveReportBacheca(idBacheca: number): void {
    this.store$.dispatch(RETRIEVE_REPORT_BACHECA({ idBacheca }));
  }

  requestExport(idDestinatari: number): void {
    this.store$.dispatch(RICHIEDI_EXPORT({ idDestinatari }));
  }

  resetRequestExport(): void {
    this.store$.dispatch(
      RICHIEDI_EXPORT_SUCCESS({ responseRequestExport: null })
    );
  }

  downloadExport(idDestinatari: number, typeComunication: string): void {
    this.store$.dispatch(DOWNLOAD_EXPORT({ idDestinatari, typeComunication }));
  }

  downloadExportBacheca(idBacheca: number, typeComunication: string): void {
    this.store$.dispatch(
      DOWNLOAD_EXPORT_BACHECA({ idBacheca, typeComunication })
    );
  }

  setCodTipologiaCp(codTipologiaCp: CodeTipologiaCPEnum): void {
    this.store$.dispatch(SET_COD_TIPOLOGIA_CP({ codTipologiaCp }));
  }

  resetCodTipologiaCp(): void {
    this.store$.dispatch(SET_COD_TIPOLOGIA_CP({ codTipologiaCp: undefined }));
  }

  resetPointDetail(): void {
    this.store$.dispatch(
      RETRIEVE_GESTIONE_PUNTOPOSTE_SUCCESS({ responsePuntoPoste: null })
    );
  }

  resetListaGestionePunti(): void {
    this.store$.dispatch(
      RETRIEVE_POINTS_LIST_SUCCESS({ responseListaGestionePunti: null })
    );
  }

  uploadFileMassive(payload: FormData): void {
    this.store$.dispatch(UPLOAD_FILE_MASSIVE({ payload }));
  }

  uploadFileMassiveData(payload: any): void {
    this.store$.dispatch(UPLOAD_FILE_MASSIVE_DATA({ payload }));
  }

  uploadFileMassiveDataAssociation(payload: any): void {
    this.store$.dispatch(UPLOAD_FILE_MASSIVE_DATA_ASSOCIATION({ payload }));
  }

  retrieveOrderHistory(payload: PayloadOrderHistory): void {
    this.store$.dispatch(RETRIEVE_ORDER_HISTORY({ payload }));
  }

  retrieveCreazioneOrdine(payload: any): void {
    this.store$.dispatch(RETRIEVE_CREATE_ORDER({ payload }));
  }

  changeQuantityCreazioneOrdine(payload: any): void {
    this.store$.dispatch(CHANGE_QUANTITY_CREATE_ORDER({ payload }));
  }

  resetOrderHistory(): void {
    this.store$.dispatch(
      RETRIEVE_ORDER_HISTORY_SUCCESS({ responseStoricoOrdini: null })
    );
  }

  downloadReportOrderHistory(payload: PayloadOrderHistory): void {
    this.store$.dispatch(DOWNLOAD_REPORT_ORDER_HISTORY({ payload }));
  }

  uploadFileMassiveAssociation(payload: FormData, category: string): void {
    this.store$.dispatch(
      UPLOAD_FILE_MASSIVE_ASSOCIATION({ payload, category })
    );
  }

  uploadFileMassiveUtilityData(payload: any, utilityType: string): void {
    this.store$.dispatch(
      UPLOAD_FILE_MASSIVE_UTILITY_DATA({ payload, utilityType })
    );
  }

  uploadFileMassiveUtility(payload: FormData, utilityType: string): void {
    this.store$.dispatch(UPLOAD_FILE_MASSIVE_UTILITY({ payload, utilityType }));
  }

  retrieveListaCatalogoMateriale(): void {
    this.store$.dispatch(RETRIEVE_LISTA_CATALOGO_MATERIALE());
  }

  retrieveListaCluster(): void {
    this.store$.dispatch(RETRIEVE_LISTA_CLUSTER());
  }

  retrieveOrderRules(): void {
    this.store$.dispatch(RETRIEVE_REGOLE_ORDINE());
  }

  resetMassiveUploadStore(): void {
    this.store$.dispatch(RESET_MASSIVE_UPLOADS_STORE());
  }

  resetCreateOrder(): void {
    this.store$.dispatch(
      RETRIEVE_CREATE_ORDER_SUCCESS({
        responseCreazioneOrdine: null,
      })
    );
  }

  retrieveConfigurazioneApprovvigionamento(): void {
    this.store$.dispatch(RETRIEVE_CONFIGURAZIONE_APPROVIGIONAMENTO());
  }

  saveListaCatalogoMateriale(payload: ISaveListaCatalogoMateriale): void {
    this.store$.dispatch(SAVE_LISTA_CATALOGO_MATERIALE({ payload }));
  }

  saveConfigurazioneApprovvigionamento(
    payload: IPayloadConfigurazioneApprovvigionamento
  ): void {
    this.store$.dispatch(SAVE_CONFIGURAZIONE_APPROVIGIONAMENTO({ payload }));
  }

  retrieveReteTerzaListCommunication(): void {
    this.store$.dispatch(RETRIEVE_LISTA_RETE_TERZA());
  }

  verifyRecipientsList(payload: any): void {
    this.store$.dispatch(VERIFY_RECIPIENTS_LIST({ payload }));
  }

  saveRecipientsList(payload: any): void {
    this.store$.dispatch(SAVE_RECIPIENTS_LIST({ payload }));
  }

  editRecipientsList(payload: IPayloadSaveRecipientsList): void {
    this.store$.dispatch(EDIT_RECIPIENTS_LIST({ payload }));
  }

  resetEditRecipientsList(): void {
    this.store$.dispatch(
      EDIT_RECIPIENTS_LIST_SUCCESS({ responseEditRecipientsList: null })
    );
  }

  retrieveHeaderDetail(idHeader: number): void {
    this.store$.dispatch(RETRIEVE_HEADER_DETAIL({ idHeader }));
  }

  resetRetrieveHeaderDetail(): void {
    this.store$.dispatch(
      RETRIEVE_HEADER_DETAIL_SUCCESS({ responseRetrieveHeaderDetail: null })
    );
  }

  saveHeaderDetail(payload: PayloadHeaderDetail): void {
    this.store$.dispatch(SAVE_HEADER_DETAIL({ payload }));
  }

  resetSaveHeaderDetail(): void {
    this.store$.dispatch(
      SAVE_HEADER_DETAIL_SUCCESS({ responseSaveHeaderDetail: null })
    );
  }

  retrieveResponseMessageBoardList(idBacheca: number): void {
    this.store$.dispatch(RETRIEVE_MESSAGGI_BACHECA({ idBacheca }));
  }

  resetResponseMessageBoardList(): void {
    this.store$.dispatch(
      RETRIEVE_MESSAGGI_BACHECA_SUCCESS({ responseMessaggiBacheca: null })
    );
  }
  retrieveResponseRecipientsBoardList(): void {
    this.store$.dispatch(RETRIEVE_DESTINATARI_BACHECA());
  }

  resetResponseRecipientsBoardList(): void {
    this.store$.dispatch(
      RETRIEVE_DESTINATARI_BACHECA_SUCCESS({ responseDestinatariBacheca: null })
    );
  }

  retrieveSaveDetailMessageBoardList(
    payload: IPayloadSaveDetailMessageBoardList
  ): void {
    this.store$.dispatch(RETRIEVE_SAVE_DETTAGLIO_MESSAGGI_BACHECA({ payload }));
  }

  resetSaveDetailMessageBoardList(): void {
    this.store$.dispatch(
      RETRIEVE_SAVE_DETTAGLIO_MESSAGGI_BACHECA_SUCCESS({
        responseSaveDetailMessageBacheca: null,
      })
    );
  }

  retrieveInvioDetailMessageBoardList(
    payload: IPayloadInvioDetailMessageBoardList
  ): void {
    this.store$.dispatch(
      RETRIEVE_INVIO_DETTAGLIO_MESSAGGI_BACHECA({ payload })
    );
  }

  retrieveInvioDetailMessageBoardListPut(
    payload: IPayloadInvioDetailMessageBoardList
  ): void {
    this.store$.dispatch(
      RETRIEVE_INVIO_DETTAGLIO_MESSAGGI_BACHECA_PUT({ payload })
    );
  }

  resetInvioDetailMessageBoardList(): void {
    this.store$.dispatch(
      RETRIEVE_INVIO_DETTAGLIO_MESSAGGI_BACHECA_SUCCESS({
        responseInvioDetailMessageBacheca: null,
      })
    );
  }

  retrieveSaveDetailMessageBoardListPut(
    payload: IPayloadSaveDetailMessageBoardListPut
  ): void {
    this.store$.dispatch(
      RETRIEVE_SAVE_DETTAGLIO_MESSAGGI_BACHECA_PUT({ payload })
    );
  }
  saveEditHeaderDetail(payload: PayloadHeaderDetail): void {
    this.store$.dispatch(SAVE_EDIT_HEADER_DETAIL({ payload }));
  }

  resetEditSaveHeaderDetail(): void {
    this.store$.dispatch(
      SAVE_EDIT_HEADER_DETAIL_SUCCESS({ responseEditSaveHeaderDetail: null })
    );
  }

  retriveListaFrazinario(payload: any): void {
    this.store$.dispatch(RETRIVE_LISTA_FRAZIONARIO({ payload }));
  }

  resetListaFrazinario(): void {
    this.store$.dispatch(
      RETRIVE_LISTA_FRAZIONARIO_SUCCESS({ responseListFrazionario: null })
    );
  }

  retrieveIdRecipients(idDestinatari: number): void {
    this.store$.dispatch(RETRIEVE_ID_RECIPIENTS({ idDestinatari }));
  }

  retrieveHeaderList(): void {
    this.store$.dispatch(RETRIEVE_HEADER_LIST());
  }

  resetRetrieveHeaderList(): void {
    this.store$.dispatch(
      RETRIEVE_HEADER_LIST_SUCCESS({ responseRetrieveHeaderList: null })
    );
  }

  editHeaderState(payload: PayloadEditStateHeader): void {
    this.store$.dispatch(EDIT_HEADER_STATE({ payload }));
  }

  resetEditHeaderState(): void {
    this.store$.dispatch(
      EDIT_HEADER_STATE_SUCCESS({ responseEditHeaderState: null })
    );
  }

  resetMassiveDataStore() {
    this.store$.dispatch(RESET_MASSIVE_UPLOADS_STORE());
  }
  resetAnagraphicStore() {
    this.store$.dispatch(RESET_ANAGRAPHIC_STORE());
  }
  resetMonitoringStore() {
    this.store$.dispatch(RESET_MONITORING_STORE());
  }
  resetRendicontazioneStore() {
    this.store$.dispatch(RESET_RENDICONTAZIONE_STORE());
  }
  resetReportReteTerzaStore() {
    this.store$.dispatch(RESET_RETE_TERZA_STORE());
  }
  resetUtilityStore() {
    this.store$.dispatch(RESET_UTILITY_STORE());
  }

  resetAllStores() {
    this.resetMassiveDataStore();
    this.resetAnagraphicStore();
    this.resetMonitoringStore();
    this.resetRendicontazioneStore();
    this.resetReportReteTerzaStore();
    this.resetUtilityStore();
  }

  resetAnagraphicCp(): void {
    this.store$.dispatch(RETRIEVE_CP_SUCCESS({ responseCP: null }));
  }

  deleteElBacheca(idBacheca: number): void {
    this.store$.dispatch(DELETE_EL_BACHECA({ idBacheca }));
  }

  resetDeleteElBacheca(): void {
    this.store$.dispatch(
      DELETE_EL_BACHECA_SUCCESS({ responseDeleteElBacheca: null })
    );
  }

  retrievePinRecovery(payload: IPinRecoveryPayload): void {
    this.store$.dispatch(RETRIEVE_PIN_RECOVERY({ payload }));
  }

  monitoringStoricoIcon(payload: IPayloadStoricoIcon): void {
    this.store$.dispatch(RETRIEVE_STORICO_ICON({ payload }));
  }

  resetNuovaOperazione(): void {
    this.store$.dispatch(
      UPLOAD_FILE_NEW_OPERATION_SUCCESS({ responseNuovaOperazioneFile: null })
    );
  }
}
